<template>
  <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
  <v-sheet color="bg1" height="100%" width="100%">
    <v-card height="100%" flat class="rounded-0 rounded-tl-lg pa-4">
      <div
        class="pa-2 d-flex align-center"
        style="gap: 8px"
        :class="{
          'flex-wrap': $vuetify.breakpoint.xs,
        }">
        <CreateInspectionsFromHarvesterPopup
          v-if="showCreateInspectionPopup"
          @open_3d_viewer="$emit('open_3d_viewer')"></CreateInspectionsFromHarvesterPopup>

        <v-sheet class="w-100 d-flex align-center justify-space-between">
          <h3>Tag Harvester</h3>
          <v-switch v-model="useMoniker" label="Use Moniker"></v-switch>
        </v-sheet>
      </div>
      <div class="expanded-section">
        <LoadingPopup
          v-if="showProgress"
          :show="showProgress"
          style="position: relative"></LoadingPopup>
        <div class="" v-if="!showProgress">
           <EnhancedTagMasterData @upload-complete="onUploadComplete"></EnhancedTagMasterData>
        </div>
        <div
          class="section-top-bar"
          v-if="!showProgress && (harvesters.length > 0 || !!debounceSearch)">
          <div style="padding: 0px">
            <v-text-field
              outlined
              dense
              hide-details
              clearable
              v-virtual-keyboard
              append-icon="mdi-magnify"
              height="40px"
              label="Search"
              style="width: 100%"
              class="v-min-input"
              placeholder="Search..."
              v-model="debounceSearch">
            </v-text-field>
          </div>
          <v-btn @click="addEquipments" width="200" color="primary">New Search</v-btn>
          <v-btn
            @click="captureAllHarvestersThumbnails"
            width="200"
            color="primary"
            v-has="permissions.TagHarvester.Create">
            Add All Images
            <span v-if="isExpanded && !!pendingRequests" class="pending-requests-counter"
              >Pending: {{ pendingRequests }}</span
            >
          </v-btn>
          <v-btn
            @click="deleteAllHarvesters"
            width="200"
            color="primary"
            v-has="permissions.TagHarvester.Delete"
            >Remove All</v-btn
          >
        </div>

        <div
          v-has="permissions.TagHarvester.Create"
          class="no-tags-section"
          v-if="!showProgress && !harvesters.length">
          <span>Model Harvester</span>
          <v-btn @click="addEquipments()" color="primary">New Search</v-btn>
        </div>

        <div class="harvesters-container" v-else>
          <HarvesterInfoController
            v-for="(harvester, index) in harvesters"
            :key="harvester.id"
            :harvester="harvester"
            :search="searchText"
            :style="{ '--harvester-delay': `${index * 60}ms` }"
            @open_3d_viewer="$emit('open_3d_viewer')"></HarvesterInfoController>
        </div>
      </div>
    </v-card>
  </v-sheet>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import 'ag-grid-community/styles/ag-grid.css';
  import 'ag-grid-community/styles/ag-theme-alpine.css';

  import tagHoverSrc from '@/images/tagHover.png';
  import { toggleExpandComponent } from '@/scripts/js/forgeviewer';
  import HttpService from '@Utils/httpService';
  import { downloadTextInFile, readFileContent } from '@/scripts/js/forgeService';
  import { postDataAsync, editType, saveTags } from '@Utils/mongoUtils';
  import EnhancedTagMasterData from '@/components/admin/components/enhancedTagMasterData.vue';
  import HarvesterInfoController from '@/components/admin/components/harvesterInfoController.vue';
  import CreateInspectionsFromHarvesterPopup from '@/components/admin/popups/createInspectionsFromHarvesterPopup.vue';
  import permissions from '@Share/config/permissions';
  import { log, error } from '@/utils/debugLogger';

  export default {
    name: 'AdminAutomaticTags',
    components: {
      LoadingPopup: () => import('@/components/common/loadingPopup.vue'),
      EnhancedTagMasterData,
      HarvesterInfoController,
      CreateInspectionsFromHarvesterPopup,
    },
    data() {
      return {
        permissions,
        searchText: '',
        tempValue: '',
        timeout: null,
        isExpanded: false,
        tagHoverImage: tagHoverSrc,
        shownTagsLength: 20,
        showProgress: true,
        isDownloading: false,
        selected_items: [],
      };
    },
    mounted() {
      this.$store
        .dispatch('UPDATE_HARVESTED_NODES_IDS')
        .then(this.$store.dispatch('FETCH_ADMIN_HARVESTERS'))
        .then(() => {
          log(`⛏️ Fetching all harvesters completed.`);
          this.showProgress = false;
        });
    },
    methods: {
      onUploadComplete(uploadInfo) {
        log('Upload completed:', uploadInfo);

        // Emit event for parent components
        this.$emit('tag-upload-complete', uploadInfo);
      },

      loadMoreTags(reload) {
        let index = reload ? 0 : this.automaticTags.length;
        if (reload) {
          this.shownTagsLength = 20;
        }
        return this.$store.dispatch('FETCH_ADMIN_AUTOMATIC_TAGS', {
          assetId: this.$route.params.id,
          reload: reload,
          index: index,
          range: this.shownTagsLength,
          searchText: this.searchText,
        });
      },
      addGroupImages(group) {
        if (!group.tags || !group.tags.length || !group.tags[0].tagHarvesterId) return;
        this.$store.dispatch('GET_AUTOMATIC_TAGS_NEED_IMAGES_IDS_BY_GROUP', {
          groupInfo: group.tags[0].tagHarvesterId,
          callback: (result) => {
            this.fillTagsImages();
          },
        });
      },
      captureAllHarvestersThumbnails() {
        if (this.showProgress) {
          this.$dialog.notify.warning('Please wait for the current process to finish.', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }

        this.$store
          .dispatch('GET_HARVESTER_TAGS_NEEDS_IMAGES_IDS', {
            harvestersIds: this.harvesters.map((t) => t.id),
          })
          .then((tags) => {
            if (tags.length == 0) {
              this.$dialog.notify.warning('No tags found!', {
                position: 'top-right',
                timeout: 3000,
              });
              return;
            }

            let callback = () => {
              log(`Start capturing thumbnail to all harvesters`);
              this.showProgress = false;
              this.$store.commit('SET_FILLING_HARVESTER_TAGS_THUMBNAILS', true);
              this.$store.commit('SET_HARVESTER_TAGS_TO_CAPTURE', tags);
            };

            this.showProgress = true;

            if (this.$store.state.viewer) {
              callback();
            } else {
              this.$dialog.notify.warning('Model is loading, please wait!', {
                position: 'top-right',
                timeout: 3000,
              });
              this.$store.commit('SET_ADMIN_MODEL_GEOMETRY_LOADED_CALLBACK', callback);
              this.$emit('open_3d_viewer');
            }
          })
          .catch((error) => {
            error(error.message);
          });
      },
      addAllGroupsImages() {
        this.$store.commit('SET_SELECTED_AUTOMATIC_TAGS_GROUP', null);
        this.fillTagsImages();
      },
      fillTagsImages() {
        if (this.shownGroups.length == 0) {
          this.$dialog.notify.warning('No equipments found!', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }
        this.$emit('open_3d_viewer');
        this.showProgress = true;
        this.$store.dispatch('fetchAllAutomaticTagsDbids', {
          assetId: this.$route.params.id,
          callback: () => {
            this.showProgress = false;
            this.$store.commit('SET_FILLING_AUTOMATIC_TAGS_IMAGES', true);
          },
        });
      },
      onScroll($event) {
        var elem = $event.target;
        if (
          elem.scrollWidth - elem.scrollLeft < 0.1 * elem.scrollWidth &&
          this.shownTagsLength < this.maxLength
        ) {
          this.shownTagsLength += 100;
          this.loadMoreTags(false);
        }
      },
      toggleExpanded() {
        toggleExpandComponent(this);
      },
      addEquipments() {
        this.$store.state.showAddAutoTagsPopup = true;
      },
      deleteAllHarvesters() {
        this.$dialog.error({
          text: 'Are you sure you want to delete all harvesters?',
          title: 'Delete Harvesters',
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                let promises = [];

                this.harvesters.forEach((harvester) => {
                  promises.push(
                    HttpService.post({
                      url: `api/harvester/deleteHarvester/${harvester.id}`,
                    }),
                  );
                });

                return Promise.allSettled(promises)
                  .then(() => {
                    this.$dialog.notify.success('All harvesters deleted successfully.', {
                      position: 'top-right',
                      timeout: 3000,
                    });

                    this.$store
                      .dispatch('UPDATE_HARVESTED_NODES_IDS')
                      .then(this.$store.dispatch('FETCH_ADMIN_HARVESTERS'))
                      .catch((error) => {
                        error(error.message);
                      });
                  })
                  .catch((error) => {
                    error(error.message);
                  });
              },
            },
          },
        });
      },
      deleteGroup(group) {
        this.$dialog.error({
          text: `Are you sure, you want to delete group "${group.info.title}"?`,
          title: 'Delete Group',
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                this.showProgress = true;
                return HttpService.post({
                  url: `api/equipments/deleteAutomaticTagsByInfo?assetId=${this.$route.params.id}&harvesterId=${group.tags[0].tagHarvesterId}`,
                })
                  .then((response) => {
                    let autoTags = this.$store.getters['GET_AUTOMATIC_TAGS'];
                    let tags = autoTags.filter((o) => o.tagHarvesterId == group.info.id);
                    tags.forEach((tag) => {
                      var index = autoTags.indexOf(tag);
                      autoTags.splice(index, 1);
                    });
                    this.updateSelectedItems();
                    this.$store.state.TAGS.allExistingAutomaticDbids = [];
                    this.showProgress = false;
                  })
                  .catch((error) => {
                    this.showProgress = false;
                  });
              },
            },
          },
        });
      },
      updateSelectedItems() {
        this.selected_items = this.$store.getters['GET_AUTOMATIC_TAGS'].filter((o) => o.isSelected);
      },
      zoomToTag(element) {
        this.$emit('open_3d_viewer');
        if (this.$store.state.viewer) {
          this.$store.state.forgeService.zoomInAllAvailableViewers(element, true);
        } else {
          this.$store.state.forgeService.tagToZoomToIn3D = element;
        }
      },
      downloadAll() {
        if (this.isDownloading) return;
        this.isDownloading = true;
        postDataAsync(
          `api/equipments/downloadCSVByGroupString?assetId=${this.$route.params.id}`,
          {},
          (res) => {
            this.isDownloading = false;
            downloadTextInFile('Auto Equipments.csv', res);
          },
        );
      },
      deleteAll() {
        if (this.shownGroups.length == 0) {
          this.$dialog.notify.warning('No equipments found to delete!', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }

        this.$dialog.error({
          text: 'Are you sure you want to delete all automatic equipments?',
          title: 'Delete Equipments',
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                this.showProgress = true;
                HttpService.post({
                  url: `api/equipments/deleteAllAutomaticTags?assetId=${this.$route.params.id}`,
                })
                  .then((response) => {
                    this.$store.commit('SET_AUTOMATIC_TAGS', []);
                    this.updateSelectedItems();
                    this.$store.state.TAGS.allExistingAutomaticDbids = [];
                    this.showProgress = false;
                  })
                  .catch((error) => {
                    this.showProgress = false;
                    log(error);
                  });
              },
            },
          },
        });
      },
      deleteSelectedItems() {
        if (this.selected_items.length == 0) {
          this.$dialog.notify.warning('No equipments selected, please select equipments first.', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }

        this.$dialog.error({
          text: 'Are you sure you want to delete selected equipments?',
          title: 'Delete Equipments',
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                this.showProgress = true;
                saveTags(this.selected_items, editType.DELETE_TAGS);
                let tags = this.$store.getters['GET_AUTOMATIC_TAGS'];
                this.selected_items.forEach((tag) => {
                  var index = tags.indexOf(tag);
                  tags.splice(index, 1);
                });
                this.updateSelectedItems();
                this.$store.state.TAGS.allExistingAutomaticDbids = [];
                this.showProgress = false;
              },
            },
          },
        });
      },
      populateGroupProperties(group) {
        this.$store.commit('SET_POPULATE_AUTOMATIC_TAGS_GROUP', group.tags[0].tagHarvesterId);
        this.$store.commit('SET_SHOW_POPULATE_AUTOMATIC_TAGS_POPUP', true);
        this.$emit('open_3d_viewer');
      },
      updateHarvester(info) {
        this.$store.commit('SET_TAG_HARVESTER_INFO', {
          id: info.id,
          title: info.title,
          matchingCategory: '',
          matchingProperty: '',
          ...JSON.parse(info.metaData),
        });
        this.$store.state.showAddAutoTagsPopup = true;
      },
      downloadCSV(group) {
        if (group.isDownloading) return;
        group.isDownloading = true;
        postDataAsync(
          `api/equipments/downloadCSVByGroupString?assetId=${this.$route.params.id}&harvesterId=${group.info.id}`,
          {},
          (res) => {
            group.isDownloading = false;
            downloadTextInFile('Auto Equipments.csv', res);
          },
        );
      },
      showCSVBrowse(group) {
        if (group.isUploading) return;
        document.getElementById('uploadCSVTags').click();
      },
      uploadCSV(group) {
        var textInput = document.getElementById('uploadCSVTags');
        group.isUploading = true;
        readFileContent(textInput.files[0]).then((content) => {
          postDataAsync(`api/equipments/updateAutoEquipmentsFromCSV`, content, () => {
            group.isUploading = false;
            this.$dialog.notify.success('Equipments updated successfully.', {
              position: 'top-right',
              timeout: 3000,
            });
          });
        });
      },
      onClearSelection() {
        this.selected_items.forEach((o) => (o.isSelected = false));
        this.updateSelectedItems();
      },
      onToggleSelection(data) {
        let { item, value } = data;
        item.isSelected = value;
      },
    },
    computed: {
      debounceSearch: {
        get() {
          return this.tempValue;
        },
        set(val) {
          this.tempValue = val;
          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            this.searchText = this.debounceSearch;
          }, 600);
        },
      },
      harvesters: {
        get() {
          return this.$store.getters['GET_HARVESTERS'];
        },
      },
      shownGroups() {
        let tags = this.$store.getters['GET_AUTOMATIC_TAGS'];
        if (tags.length == 0) return [];
        const groupByString = tags.reduce((group, tag) => {
          const { tagHarvester } = tag;
          if (!group[tagHarvester.id]) {
            group[tagHarvester.id] = {
              data: [],
              info: tagHarvester,
            };
          }
          group[tagHarvester.id].data.push(tag);
          return group;
        }, {});
        let groupsNames = Object.getOwnPropertyNames(groupByString);
        let res = groupsNames.map((o) => {
          return {
            info: groupByString[o].info,
            tags: groupByString[o].data,
            shownTags: groupByString[o].data,
            isExpanded: true,
            isUploading: false,
            isDownloading: false,
          };
        });
        return res;
      },
      automaticTags() {
        return this.$store.getters['GET_AUTOMATIC_TAGS'];
      },
      showAddAutoTagsPopup() {
        return this.$store.state.showAddAutoTagsPopup;
      },
      maxLength() {
        return this.$store.getters['GET_AUTOMATIC_TAGS'].length;
      },

      pendingRequests: {
        get() {
          return this.$store.getters['GET_REQUESTED_IMAGES_IDS']?.length ?? 0;
        },
      },
      showCreateInspectionPopup: {
        get() {
          return this.$store.state.showCreateInspectionPopup;
        },
        set(value) {
          this.$store.state.showCreateInspectionPopup = value;
        },
      },
      useMoniker: {
        get() {
          return this.$store.state.useMoniker;
        },
        set(value) {
          this.$store.state.useMoniker = value;
        },
      },
    },
    watch: {
      showAddAutoTagsPopup: {
        handler: function (value, old) {
          if (!!old && !value && !!this.searchText) {
            this.loadMoreTags(true);
          }
        },
      },
    },
  };
</script>

<style>
  /* .ag-theme-alpine {
    --ag-alpine-active-color: var(--v-primary-base);
    --ag-border-color: #ad508651 !important;
    --ag-input-focus-border-color: #ad508651 !important;
    --ag-selected-row-background-color: #ad508651 !important;
    --ag-row-hover-color: #ad50871a !important;
    --ag-alpine-active-color: #ad5087 !important;
    --ag-row-border-color: #ad508651 !important;
  } */

  #tagHarvesterSection .row-input {
    padding: 10px 40px;
    justify-content: flex-start;
  }

  .no-tags-section .admin-btn.new-search-btn {
    width: 250px;
    border-radius: 20px;
    font-size: 14px !important;
    line-height: 12px !important;
    text-transform: capitalize;
  }

  .pending-requests-counter {
    font-size: 12px;
    margin-inline-start: 30px;
    color: #faff1c;
    font-weight: 600;
  }

  .add-property {
    color: white;
    background-color: var(--v-primary-base);
    border-radius: 19px;
    cursor: pointer;
    width: 30px;
    height: 30px;
    text-align: center;
    font-size: 17px;
    padding-top: 6px;
    box-sizing: border-box;
    margin-left: 10px;
  }

  .add-property:hover {
    background-color: var(--v-primary-lighten3);
  }

  .property-column2 {
    width: 20%;
    margin: 0 5px;
  }

  .tag-icon {
    background-size: cover;
    background-image: url(../../../images/tagHover.png);
    width: 23px;
    height: 23px;
    margin-right: 10px;
  }

  .delete-btn {
    color: red;
    cursor: pointer;
    font-size: 13px;
  }

  .delete-btn:hover {
    color: rgb(255, 63, 63);
  }

  .spinning {
    animation: spin 2s linear infinite !important;
  }

  .section-top-bar {
    display: flex;
    justify-content: start;
    align-items: center;
    padding: 10px;
    column-gap: 5px;
  }

  #tagHarvesterSection .expanded-section {
    animation: none;
  }

  .section-top-bar > div {
    width: 100%;
    max-width: 25%;
    margin: 0px 2px;
    padding: 11px;
    font-size: 13px;
  }

  .harvesters-container {
    padding: var(--ds-space-md);
    display: flex;
    flex-direction: column;
    gap: var(--ds-space-sm);

    /* Container ambient glow for visual grouping */
    background: linear-gradient(
      180deg,
      transparent 0%,
      var(--ds-surface-hover) 100%
    );
    border-radius: var(--ds-radius-md);
    position: relative;

    /* Subtle inset effect */
    box-shadow: inset 0 1px 3px var(--ds-border-subtle);
  }

  .theme--dark .harvesters-container {
    background: linear-gradient(
      180deg,
      transparent 0%,
      rgba(255, 255, 255, 0.02) 100%
    );
  }

  #tagHarvesterSection .section-top-bar input {
    height: 32px;
  }
  #tagHarvesterSection .section-top-bar .admin-btn {
    line-height: 9px;
  }
  #tagHarvesterSection .section-top-bar > div {
    font-size: 12px;
  }

  .no-tags-section {
    display: flex;
    align-items: center;
    margin: 15px 10px;
    column-gap: 40px;
  }

  .no-tags-section span {
    font-size: 16px;
    font-weight: 600;
  }

  .grid-container .ag-theme-alpine {
    --ag-row-hover-color: #ad50871a !important;
    --ag-row-hover-color: #ad50871a !important;
  }

  .grid-container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 !important;
  }

  .grid-container input {
    height: auto;
    font-weight: 400;
    color: inherit !important;
  }

  .ag-theme-alpine,
  .ag-theme-alpine-dark {
    --ag-range-selection-border-color: transparent !important;
  }

  .ag-ltr .ag-cell,
  .ag-header-cell,
  .ag-header-group-cell {
    border-right: var(--ag-borders-critical) var(--ag-border-color) !important;
  }

  .ag-header-cell.text-center .ag-header-cell-label {
    display: flex;
    justify-content: center;
  }

  .harvesters-container .ag-root-wrapper {
    min-height: auto !important;
  }
</style>
